module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dof-cell', {
    attrs: {
      "title": _vm.title,
      "has-arrow": false,
      "has-top-border": _vm.hasTopBorder,
      "has-sub-bottom-border": true,
      "cell-style": {
        backgroundColor: _vm.backgroundColor
      },
      "disabled": _vm.disabled,
      "accessible": true,
      "aria-label": (_vm.title + ",状态为" + (_vm.checked ? '已选中' : '未选中') + "," + (_vm.disabled ? '不可更改' : '')),
      "data-evt-dofCellClicked": ""
    },
    on: {
      "dofCellClicked": _vm.dofCellClicked
    }
  }, [(_vm.radioIcon) ? _c('figure', {
    staticClass: "radio weex-el weex-image",
    attrs: {
      "slot": "switch",
      "src": _vm.radioIcon,
      "data-img-src": _vm.radioIcon,
      "weex-type": "image"
    },
    slot: "switch"
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8dbc89c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dbc89c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-radio/item.vue
// module id = 654
// module chunks = 0 1